// extracted by mini-css-extract-plugin
export default {"r_l":"_15340037dc _7f59faf81f","t":"b24ced47de"};